module.exports = __webpack_public_path__ + "d4e12e8e9e242435ab9cbd5a2086ca2c.woff2";